import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { csColorAction, csColorBackground, csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'

export const style = css`
  .main-container {
    display: flex;
    gap: ${csSpacing.spacing08};
    align-items: flex-start;
    
    @media(max-width: ${SCREENS.medium}) {
      flex-direction: column;
      gap: ${csSpacing.spacing06};
    }
  }

  .speed-order-section {
    flex: 1;
  }

  .toast-section {
    flex: 0 0 auto;
    position: sticky;
    top: ${csSpacing.spacing08};
    
    @media(max-width: ${SCREENS.medium}) {
      position: static;
      width: 100%;
    }
  }

  .speed-order-container {
    position: relative;
  }

  /* Drag and Drop Overlay */
  .drag-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.95);
    
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    backdrop-filter: blur(2px);
    opacity: 1;
    transition: opacity 0.15s ease-in-out;
  }

  .drag-overlay:not([style*="display: none"]) {
    animation: fadeIn 0.15s ease-in-out;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.98);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .drag-overlay-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${csSpacing.spacing08};
    text-align: center;
  }

  .drag-icon {
    font-size: 4rem;
    color: ${csColorBackground.primary};
    background-color:${csColorAction.linkPrimary} ;
    border-radius: 50%;
    padding: 1rem;
    width: 6rem;
    height: 6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .drag-text {
    color: var(--cse-color-text-heading);
    font-weight: 600;
  }

  .alert-container {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing08};
    position: relative;
    transition: all 0.2s ease;
  }

   cse-paper {
    flex: 1;
    --cse-paper-row-gap: ${csSpacing.spacing07};
  }

  .button-link-container {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
  .button-link-container-inner {
    display: flex;
    align-items: center;
    column-gap: ${csSpacing.spacing08};
    row-gap: ${csSpacing.spacing06};
    flex-wrap: wrap;
  }

  .file-validation-error {
    --cse-text-color: ${csColorFunctional.error};
    margin-top: ${csSpacing.spacing04};
  }


  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .form-button-group {
    display: flex;
    flex-direction: row;
    gap: ${csSpacing.spacing06};  
  }

  .form-button-group cse-button {
    @media(max-width: ${SCREENS.small}) and (max-width: ${SCREENS.medium}) {
      width: 100%;
    }
  }

  .loader-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  cse-modal cse-text.success-modal-text{
    --cse-text-text-align: center;
  }

  /* Mobile Styles */
   .alert-container {
    @media(max-width: ${SCREENS.small}) {
      gap: ${csSpacing.spacing06};
    }
    @media(max-width:${SCREENS.medium}) {
      gap: ${csSpacing.spacing06};
    }
  }

  slot[name="actions"] {
    @media(max-width: ${SCREENS.small}) {
      flex-direction: column;
      align-items: stretch;
      gap: ${csSpacing.spacing06};
    }
    @media(max-width:${SCREENS.medium}) {
      flex-direction: row;
      align-items: stretch;
      gap: ${csSpacing.spacing06};
    }
  }

  slot[name="actions"] cse-button {
    @media(max-width: ${SCREENS.small}) {
      width: 100%;
    }
    @media(max-width:${SCREENS.medium}) {
      width: 100%;
    }
  }

  .buttons-container {
    @media(max-width: ${SCREENS.small}) {
      flex-direction: column;
      gap: ${csSpacing.spacing06};
      align-items: stretch;
    }
    
  }

  .order-all-button::part(button) {
    @media(max-width: ${SCREENS.small}) {
    width: 100%;
    
    }
    @media(max-width:${SCREENS.medium}) {
      width: 100%;
    }
  }

  .form-button-group cse-button::part(button) {
    @media(max-width: ${SCREENS.small}) {
    width: 100%;
    }
    
  }
`
